<template>
  <div>
    <label for="DropOffName" class="uk-form-label">Name</label>
    <div class="tw-mt-2 tw-flex tw-w-full tw-items-center tw-gap-2">
      <div class="tw-min-w-0 tw-flex-1">
        <FilterableDropdown
          id="DropOffName"
          v-model="selectedCustomer"
          :options="customers"
          :customLabel="(option) => (option && (option.displayName || option.name)) || ''"
          class="tw-w-full tw-min-w-0"
          @search-change="onCustomerSearch"
        ></FilterableDropdown>
      </div>
      <div
        class="tw-inline-flex tw-h-10 tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/70"
      >
        <button
          type="button"
          class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
          :disabled="!selectedCustomer"
          uk-tooltip="Please Select customer"
          title="Save"
          aria-label="Save"
          @click="saveCustomer"
        >
          <font-awesome-icon icon="check" />
        </button>
        <div class="tw-w-px tw-bg-slate-200/70"></div>
        <button
          type="button"
          class="tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white"
          title="Cancel"
          aria-label="Cancel"
          @click="cancelCustomerEdit"
        >
          <font-awesome-icon icon="xmark" />
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ReceivingCustomersQuery from '@/gql/customers/ReceivingCustomers.gql';
import BillingCustomersQuery from '@/gql/customers/BillingCustomers.gql';
import EditDropoffCustomer from '@/gql/orders/mutations/EditDropoffCustomer.gql';
import EditBillingCustomer from '@/gql/orders/mutations/customers/EditBillingCustomer.gql';

import FilterableDropdown from '../../core/FilterableDropdown.vue';

export default defineComponent({
  props: {
    receiving: {
      default: true,
    },
    orderId: {
      required: true,
    },
    currentCustomerId: {
      required: false,
    },
    currentCustomer: {
      required: false,
    },
  },
  components: {
    FilterableDropdown,
  },
  data() {
    return {
      selectedCustomerId: null as any,
      selectedCustomer: null as any,
      customerQuery: '',
      customers: [] as any[],
    };
  },
  watch: {
    currentCustomerId: {
      immediate: true,
      handler(val: any) {
        const vm = this as any;
        vm.selectedCustomerId = val ?? null;
        const resolved = (vm.customers || []).find((c: any) => String(c?.id) === String(vm.selectedCustomerId));
        vm.selectedCustomer = resolved || vm.currentCustomer || null;
      },
    },
    customers: {
      immediate: true,
      handler(val: any[]) {
        const vm = this as any;
        if (vm.selectedCustomer && vm.selectedCustomer.id) return;
        const resolved = (val || []).find((c: any) => String(c?.id) === String(vm.selectedCustomerId));
        if (resolved) {
          vm.selectedCustomer = resolved;
          return;
        }
        if (!vm.selectedCustomer && vm.currentCustomer) {
          vm.selectedCustomer = vm.currentCustomer;
        }
      },
    },
  },
  methods: {
    onCustomerSearch(customerName: string) {
      (this as any).customerQuery = customerName;
    },
    cancelCustomerEdit() {
      (this as any).$emit('cancelCustomerEdit');
    },
    saveCustomer() {
      const vm = (this as any);

      const customerIdRaw = vm.selectedCustomer?.id ?? vm.selectedCustomerId;
      const orderIdRaw = vm.orderId;

      const customerId =
        customerIdRaw === null || customerIdRaw === undefined || customerIdRaw === ''
          ? null
          : Number(customerIdRaw);
      const orderId =
        orderIdRaw === null || orderIdRaw === undefined || orderIdRaw === ''
          ? null
          : Number(orderIdRaw);

      if (!orderId || !customerId) {
        return;
      }

      vm.$apollo
        .mutate({
          mutation: vm.receiving ? EditDropoffCustomer : EditBillingCustomer,
          variables: {
            orderId,
            customerId,
          },
        })
        .then((data) => {
          vm.isEditingReceivingCustomer = false;
          vm.selectedCustomerId = null;
          vm.selectedCustomer = null;
          vm.$emit('saveCustomer');
        })
        .catch((err) => {
          vm.isEditingReceivingCustomer = false;
          vm.selectedCustomerId = null;
          vm.selectedCustomer = null;
          console.error('Could not update reference number');
          console.error(err);
        });
    },
  },
  apollo: {
    customers: {
      query() {
        const vm = (this as any);

        if (vm.receiving) return ReceivingCustomersQuery;

        return BillingCustomersQuery;
      },
      debounce: 100,
      variables() {
        // Use vue reactive properties here
        return {
          name: (this as any).customerQuery,
        };
      },
      update: (data) => data.receivingCustomers || data.billingCustomers,
    },
  },
});
</script>